import React from "react";
import { useAuth } from "@/lib/auth";
import StudentProfile from "@/pages/student/Profile";
import StaffProfile from "@/pages/StaffProfile";

/**
 * Role-aware profile page mounted at /me/profile.
 *
 * - Students keep the rich enrolment/certificate dashboard
 *   (`StudentProfile`).
 * - Admins, SMEs and instructors see a clean staff-facing view
 *   with their identity card, security section (password + 2FA toggle),
 *   and any role-specific actions.
 *
 * This was previously hard-coded to `StudentProfile`, which led admins
 * to a page full of "GraduationCap" icons, "HCC-YYYY-NNNN student id"
 * and empty enrolment tables — confusing and unprofessional.
 */
export default function AccountProfile() {
    const { user, loading } = useAuth();
    if (loading || !user) return null;
    if (user.role === "student") return <StudentProfile />;
    return <StaffProfile />;
}
